<template>
    <div class="container-fluid">
        <v-title :lineage="[{'Settings':'settings'}]">
            Users
            <div slot="actions">
                <router-link
                    v-if="$auth.$pages['add-user'].isAllowed"
                    :to="{name: 'add-user'}"
                    class="btn btn-link">Add User<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>
            </div>
        </v-title>
        <div class="grid">
            <div class="grid-item">
                <grid
                    :columns="gridColumns"
                    :provider="provider"
                    :options="gridOptions"
                    @completed="stopLoadingPage"
                    :tabs="gridTabs"
                    :filter-set="gridFilterSet"
                >
                    <v-no-content slot="no-content">
                        <span slot="title">It seems that you have no Users</span>
                        <span slot="description">Click on the button below to add your first User.</span>
                        <div slot="actions">
                            <router-link
                                v-if="$auth.$pages['add-user'].isAllowed"
                                :to="{name: 'add-user'}"
                                class="btn btn-link">Add User<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>                        </div>
                    </v-no-content>
                </grid>
            </div>
        </div>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import {vIcon} from '@/components/form';
    import vNoContent from '@/components/v-no-content';
    import Grid from '@/components/grid/grid';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import {createDialog, vConfirm} from '@/components/modal/dialogs';
    import TabsConfiguration from '@/components/grid/tabs/tabs-configuration';
    import userColumns from './user-columns';
    import userFilters from '@/common/query/filter/user-filters';
    import FilterSet from '@/components/query/filter-set';

    export default {
        name: 'users',
        components: {
            vTitle, vIcon, Grid, vNoContent,
        },
        mixins: [LoadStateMixin],
        data() {
            return {
                gridColumns: userColumns(this.showDeleteUserDialog, this.showResendEmailDialog),
                gridTabs: new TabsConfiguration({
                    id: 'users-list',
                    store: this.$store,
                    systemTabs: [
                        {
                            label: 'All',
                            sortBy: {processedTime: 'desc'},
                        },
                    ],
                    version: 1,
                    filtersVersion: userFilters.version,
                }),
                gridOptions: {
                    defaultSort: {createdTime: 'desc'},
                },
                gridFilterSet: new FilterSet({store: this.$store, ...userFilters}),
                isDataReady: true,
            };
        },
        methods: {
            async showResendEmailDialog(data, grid) {
                const confirmDialog = createDialog(vConfirm, this);
                const dialogParams = {
                    title: 'Resend Confirmation Email',
                    content: `You are about to send a confirmation email to ${data.fields.email}. Do you wish to proceed?`,
                    confirmLabel: 'Sent',
                };
                if (await confirmDialog(dialogParams)) {
                    this.resendConfirmationEmail(data, grid);
                }
            },
            async showDeleteUserDialog(data, grid) {
                const confirmDialog = createDialog(vConfirm, this);
                const dialogParams = {
                    title: 'Delete User',
                    content: 'Are you sure you want to delete this user?',
                    confirmLabel: 'Delete',
                    dangerConfirm: true,
                };
                if (await confirmDialog(dialogParams)) {
                    this.deleteUser(data, grid);
                }
            },
            async resendConfirmationEmail({fields}, grid) {
                try {
                    const data = {
                        email: fields.email,
                    };
                    grid.startLoading();
                    await this.$api(({account}) => account.forgotPassword({data}));
                    grid.fetchData();
                    this.$toast.positive(`Confirmation email was sent to ${fields.email} successfully.`);
                } catch (error) {
                    this.$toast.fromError(error);
                    grid.stopLoading();
                }
            },
            async deleteUser(data, grid) {
                try {
                    const params = {
                        id: data.fields.id,
                    };
                    grid.startLoading();
                    await this.$api(({users}) => users.delete(params));
                    grid.fetchData();
                    this.$toast.positive('User successfully deleted');
                } catch (error) {
                    this.$toast.fromError(error);
                    grid.stopLoading();
                }
            },
            provider(params) {
                return this.$api(({users}) => users.getAll(params));
            },
        },
    };
</script>
